import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import AbstractColumnActions from "../../shared/entity/TableColumnAction";
import VereficationStatus from "modules/shared/profiles/VereficationStatus";

// EuiTable format
const columns = (actions, entityName) => [
    {
        field: "id",
        name: "ID",
        render: (item) => (
            <span>
                <Link to={entityName ? `/database/${entityName}/${item}` : ""}>#{item}</Link>
            </span>
        ),
        sortable: true,
        width: 70,
    },
    {
        field: "name",
        name: <FormattedMessage id="supplier.name" />,
        sortable: true,
        render: (item) => <b>{item}</b>,
        mobileOptions: {
            render: (item) => <b>{item.name}</b>,
            header: false,
            truncateText: false,
            enlarge: true,
            fullWidth: true,
        },
    },
    {
        field: "phoneNumber",
        name: "Phone Number",
        render: (item) => <b>{item}</b>,
        sortable: true,
        mobileOptions: {
            render: (item) => <b>{item.name}</b>,
            header: false,
            truncateText: false,
            enlarge: true,
            fullWidth: true,
        },
    },
    {
        field: "qaStatus",
        name: <FormattedMessage id="entity.verification" />,
        sortable: false,
        render: (item) => <VereficationStatus status={item} />,
        width: 160,
    },
    {
        field: "createdAt",
        name: <FormattedMessage id="supplier.created-at" />,
        dataType: "date",
        sortable: true,
    },
    {
        field: "creatorEmail",
        name: <FormattedMessage id="supplier.creator.email" />,
        sortable: false,
    },
    {
        name: "Actions",
        isActionsPopover: true,
        actions: AbstractColumnActions(actions),
    },
];

export default columns;
